import React, { useState, useContext, ReactNode } from 'react';
import { Container } from '../container';
import { CreateAddress } from '../address-modal/CreateAddress';
import { ModalContext } from '../../../modal';
import { Secondary as SecondaryButton } from '../../../button';
import { AddressBook } from './AddressBook';
import { colors } from '../../../../theme/color';
import { useUser } from '../../../../hooks/useUser';
import {
  CreateUserAddressRequest,
  UpdateUserAddressRequest,
  UserAddressDto,
} from '@kotipizzagroup/kotipizza-users-api-client';
import styled from 'styled-components';

export enum currentScreen {
  ADDRESS_BOOK,
  CREATE_ADDRESS,
}

type AddressBookProps = {
  onAddressSelect: (address: UserAddressDto | undefined) => void;
  createAddress: (address: CreateUserAddressRequest) => Promise<UserAddressDto>;
  updateAddress: (address: UpdateUserAddressRequest) => Promise<void>;
  deleteAddress: (address: UserAddressDto) => Promise<void>;
  setDefaultAddress: (address: UserAddressDto) => Promise<void>;
};

export const MobileAddressBook: React.FC<AddressBookProps> = ({
  createAddress,
  updateAddress,
  deleteAddress,
  onAddressSelect,
  setDefaultAddress,
}) => {
  const { user } = useUser();
  const [screen, setCurrentScreen] = useState<currentScreen>(currentScreen.ADDRESS_BOOK);
  const addresses = user?.addresses || [];
  const { closeModal } = useContext(ModalContext);

  const handleAddressCreate = (address: CreateUserAddressRequest): Promise<UserAddressDto> =>
    createAddress(address);

  const handleAddressSelect = (address: UserAddressDto | undefined): void => {
    onAddressSelect(address);
    closeModal();
  };

  const handleSetDefaultAddress = (address: UserAddressDto): Promise<void> =>
    setDefaultAddress(address);

  const handleAddressUpdate = (address: UpdateUserAddressRequest): Promise<void> =>
    updateAddress(address);
  const handleAddressDelete = (address: UserAddressDto): Promise<void> => deleteAddress(address);

  const renderScreen = (screen: currentScreen): ReactNode => {
    switch (screen) {
      case currentScreen.ADDRESS_BOOK:
        return (
          addresses.sort((a, b) => Number(b.primaryAddress) - Number(a.primaryAddress)) && (
            <Container backgroundColor={colors.white} borderRadius="4px">
              <AddressBookContainer>
                <AddressBook
                  onAddressSelect={handleAddressSelect}
                  updateAddress={handleAddressUpdate}
                  deleteAddress={handleAddressDelete}
                  setDefaultAddress={handleSetDefaultAddress}
                />
              </AddressBookContainer>

              <SecondaryButton onClick={() => setCurrentScreen(currentScreen.CREATE_ADDRESS)}>
                + Lisää uusi osoite
              </SecondaryButton>
            </Container>
          )
        );
      case currentScreen.CREATE_ADDRESS:
        return (
          <CreateAddress
            createAddress={handleAddressCreate}
            setDefaultAddress={setDefaultAddress}
          />
        );
      default:
        return null;
    }
  };

  return <>{renderScreen(screen)}</>;
};

const AddressBookContainer = styled.div`
  margin-bottom: 16px;
`;
